module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v",
    attrs: {
      "id": "result-page"
    }
  }, [_c('div', {
    staticClass: "choose-show-cases"
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "large",
      "fill": "#324057",
      "text-color": "#a4aebd",
      "min": 1
    },
    on: {
      "change": _vm.gooter
    },
    model: {
      value: (_vm.showCasesName),
      callback: function($$v) {
        _vm.showCasesName = $$v
      },
      expression: "showCasesName"
    }
  }, _vm._l((_vm.casesEle), function(caseOne) {
    return _c('el-checkbox-button', {
      key: caseOne.name,
      attrs: {
        "label": caseOne.name,
        "disabled": caseOne.status !== 30
      }
    }, [_vm._v(_vm._s(caseOne.name))])
  })), _vm._v(" "), _c('a', {
    staticClass: "case-db",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.goCompare
    }
  }, [_vm._v("方案对比")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ele-result-list"
  }, _vm._l((_vm.showCases), function(showCase, index) {
    return _c('div', {
      staticClass: "ele-result-one"
    }, [_c('div', {
      staticClass: "data-title",
      attrs: {
        "id": index + '_case'
      }
    }, [_vm._v("\n        " + _vm._s(showCase.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "data-chat-2"
    }, [_c('div', {
      staticClass: "case-info"
    }, [_c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("天气")]), _c('span', [_vm._v(_vm._s(showCase.d1))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("光伏成本")]), _c('span', [_vm._v(_vm._s(showCase.d2))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("固定存储容量")]), _c('span', [_vm._v(_vm._s(showCase.d3))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC下限")]), _c('span', [_vm._v(_vm._s(showCase.d4))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC上限")]), _c('span', [_vm._v(_vm._s(showCase.d5))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("SOC初始值")]), _c('span', [_vm._v(_vm._s(showCase.d6))])]), _vm._v(" "), _c('div', {
      staticClass: "case-info-one"
    }, [_c('span', [_vm._v("储能放电成本")]), _c('span', [_vm._v(_vm._s(showCase.d7))])])]), _vm._v(" "), _c('div', {
      staticClass: "case-info"
    }, [_vm._l((showCase.result.logfile), function(data, key) {
      return _c('div', {
        staticClass: "case-info-one"
      }, [_c('span', [_vm._v(_vm._s(key))]), _c('span', [_vm._v(_vm._s(data))])])
    }), _vm._v(" "), _c('div', {
      staticClass: "case-info-one show-detail"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.dialog_content = showCase.result.CompleteLogfile;
          _vm.dialogVisible = true
        }
      }
    }, [_vm._v("详 细")])])], 2), _vm._v(" "), _c('div', {
      staticClass: "map-page map-page-pre",
      attrs: {
        "id": 'chart-2-' + showCase.index
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "data-table"
    }, [_c('mii-table', {
      attrs: {
        "datas": showCase.result['调度方案'],
        "table_style": 2,
        "ths": _vm.ths,
        "title": "结果",
        "scroll_table": "true",
        "table_height": 16,
        "output_file": "true"
      }
    })], 1)])
  })), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详细",
      "visible": _vm.dialogVisible,
      "size": "",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, _vm._l((_vm.dialog_content), function(data) {
    return _c('p', [_vm._v(_vm._s(data))])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28b827c9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/ele/ele_result.vue
// module id = 965
// module chunks = 1